import { useState, useCallback } from 'react';

export type GameState =
  | { step: 'idle' }
  | { step: 'purchasing'; orderId: string }
  | { step: 'failed'; message: string };

export function useGameFlow() {
  const [state, setState] = useState<GameState>({ step: 'idle' });
  return {
    state,
    startPurchase: useCallback((orderId: string) => setState({ step: 'purchasing', orderId }), []),
    fail: useCallback((message: string) => setState({ step: 'failed', message }), []),
    reset: useCallback(() => setState({ step: 'idle' }), []),
  };
}
